import { DataCard } from '../../../components/DashboardCard';
import { useDevices } from '../../../hooks/Dashboard/useDevices';

export const DevicesCard = (props: DashboardCardProps) => {
  const { theme } = props;
  const { devices, getDevices, loading } = useDevices();

  return (
    <DataCard
      data={devices}
      title="Device"
      views={['list', 'graph', 'pie']}
      columns={[
        { name: 'Model', dataKey: 'model' },
        { name: 'In Acct', dataKey: 'inAccounts', isNumeric: true },
        { name: 'In Inv', dataKey: 'inInventory', isNumeric: true },
        { name: 'Disabled', dataKey: 'disabled' },
        { name: 'Total', dataKey: 'total', isNumeric: true },
      ]}
      leftLabel="In Acct"
      bottomLabel="Model"
      refresh={true}
      loading={loading}
      onRefresh={getDevices}
      theme={theme}
    />
  );
};
